import { CellContext, ColumnDef } from "@tanstack/react-table";
import React from "react";
import { IndicatorsProps } from "../EPDEditorStore";
import { TableCell } from "../components/EditableTable/TableCell";
import { useTranslation } from "react-i18next";

const useIndicatorsTableColumns = (columns: string[]) => {
  const { t } = useTranslation();

  return React.useMemo<ColumnDef<IndicatorsProps>[]>(
    () => [
      ...columns.map((col) => {
        if (col === "indicator") {
          return {
            id: col,
            accessorKey: col,
            header: () => (
              <div className="bg-gray-50 text-gray-900 font-semibold">
                {t("productEditor.indicator")}
              </div>
            ),
            cell: (info: { row: { original: IndicatorsProps } }) => (
              <div className="text-gray-900 font-semibold text-xs">
                {info.row.original[col] || "-"}
              </div>
            ),
          };
        } else if (col === "unit") {
          return {
            id: col,
            accessorKey: col,
            header: () => (
              <div className="bg-gray-50 text-gray-900 font-semibold">
                {t("EPDEditor.unit")}
              </div>
            ),
            cell: (info: { row: { original: IndicatorsProps } }) => (
              <div className="text-gray-700 font-medium text-xs whitespace-nowrap">
                {info.row.original.unit || "-"}
              </div>
            ),
          };
        } else {
          return {
            id: col,
            accessorKey: col,
            header: () => (
              <div className="bg-gray-50 text-gray-900 font-semibold">
                {t(`${col}`)}
              </div>
            ),
            cell: (ctx: CellContext<IndicatorsProps, unknown>) => (
              <TableCell {...ctx} inputType="number" />
            ),
          };
        }
      }),
    ],
    [columns]
  );
};

export default useIndicatorsTableColumns;
